import { phoneConfigSchema } from './config-schema.js';

export const phoneDefinition = {
  type: 'phone',
  nameKey: 'nodes.phone.name',
  subtitleKey: 'nodes.phone.subtitle',
  modalTitleKey: 'nodes.phone.title',
  icon: 'call',
  color: '#F97316',
  colorGradient: 'linear-gradient(135deg, #FB923C, #EA580C)',
  category: 'allApps',
  schema: phoneConfigSchema
};
